import ReportApi from "../../../api/report-api";

const initialState = () => ({
    isFetching: false,
    breeding: [],
    heat: []
});

const actions = {
    listReports: async ({ commit }, payload) => {
        try {
            commit("request", payload);
            const apiResponse = await ReportApi.list(payload);
            if (apiResponse && apiResponse.data) {
                commit("listReportsSuccess", {data: apiResponse.data, report_type: payload.report_type});
            } else {
                commit("listReportsFailed", apiResponse);
            }
        } catch (e) {
            commit("listReportsFailed", e);
        }
    }
}

const mutations = {
    request: (state) => {
        state.isFetching = true;
    },
    listReportsSuccess: (state, {data, report_type}) => {
        state.isFetching = false;
        state[report_type] = data;
    },
    listReportsFailed: (state) => {
        state.isFetching = false;
    }
}

export default {
    namespaced: true,
    state: initialState,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/plugins/store/modules/reports.js